import LanguageSelector from "./LanguageSelector";

type PageSectionHeaderProps = {
  children: React.ReactNode;
  className?: string;
};

/** Page title row with language selector aligned to the right of the H2/H1. */
const PageSectionHeader = ({ children, className = "mb-6" }: PageSectionHeaderProps) => {
  return (
    <div className={`flex items-start justify-between gap-4 ${className}`}>
      <div className="min-w-0 flex-1">{children}</div>
      <LanguageSelector className="shrink-0" />
    </div>
  );
};

export default PageSectionHeader;
